// ============================================================================
// JAN SEVA HOSPITAL — EDITABLE CONTENT & CONFIG
// Edit values here to update the whole website. Placeholders marked ⬅ EDIT.
// ============================================================================

export const CONFIG = {
  hospitalName: "Jan Seva Hospital",
  address: "Dr. Kishori Mohan Complex, Sikariya More, Gaya, Bihar, India",
  phonePrimary: "8521181294",
  phoneSecondary: "9199583646",
  whatsapp: "918521181294", // ⬅ EDIT WhatsApp number (with country code, no +)
  email: "INSERT_EMAIL_ADDRESS", // ⬅ EDIT hospital email address
  mapsLink: "https://maps.app.goo.gl/kvwmza3id6o5w5GKA",
  mapsEmbed: "https://maps.google.com/maps?q=24.7764404,84.9738143&z=16&output=embed",
  googleReviewsLink: "https://maps.app.goo.gl/kvwmza3id6o5w5GKA",
  domain: "INSERT_DOMAIN_NAME", // ⬅ EDIT e.g. https://jansevahospitalgaya.com
  gaId: "INSERT_GA_MEASUREMENT_ID", // ⬅ EDIT Google Analytics ID (G-XXXXXXX)
  adsId: "INSERT_GOOGLE_ADS_ID", // ⬅ EDIT Google Ads conversion ID (AW-XXXXXXX)
  hours: {
    emergency: { en: "Emergency: 24×7", hi: "आपातकाल: 24×7 उपलब्ध" },
    opd: { en: "OPD: 8:00 AM – 8:00 PM (Daily)", hi: "ओपीडी: सुबह 8:00 – रात 8:00 (प्रतिदिन)" },
  },
  images: {
    hero: "https://customer-assets-rejwkqb3.emergentagent.net/job_seva-healthcare-gaya/artifacts/7ebxefmv_ChatGPT%20Image%20Aug%207%2C%202026%2C%2009_38_06%20AM.png",
    care: "https://customer-assets-rejwkqb3.emergentagent.net/job_seva-healthcare-gaya/artifacts/osoajpdm_ChatGPT%20Image%20Aug%207%2C%202026%2C%2009_36_24%20AM.png",
    surgery: "https://customer-assets-rejwkqb3.emergentagent.net/job_seva-healthcare-gaya/artifacts/33xxvld0_ChatGPT%20Image%20Aug%207%2C%202026%2C%2009_39_16%20AM.png",
    pilesFistula: "https://static.prod-images.emergentagent.com/jobs/9d11d2dc-5564-467c-98a9-ec11148bb4b4/images/b0319bf3da3a85bbf54b4e742a59e492bd39a8e1c9f23c5cd2de43fd3b4896ff.jpeg",
  },
};

export const telLink = (n) => `tel:+91${n}`;
export const waLink = (n = CONFIG.whatsapp) =>
  `https://wa.me/${n}?text=${encodeURIComponent("Hello Jan Seva Hospital, I would like to enquire about your services.")}`;

export const NAV = [
  { id: "home", en: "Home", hi: "होम" },
  { id: "services", en: "Services", hi: "सेवाएँ" },
  { id: "doctors", en: "Doctors", hi: "डॉक्टर" },
  { id: "about", en: "About Us", hi: "हमारे बारे में" },
  { id: "emergency", en: "Emergency", hi: "आपातकाल" },
  { id: "contact", en: "Contact", hi: "संपर्क" },
];

export const SERVICES = [
  { icon: "Slice", en: { t: "General & Laparoscopic Surgery", d: "Open and minimally invasive (keyhole) surgical care for common surgical conditions." }, hi: { t: "जनरल एवं लेप्रोस्कोपिक सर्जरी", d: "सामान्य सर्जिकल स्थितियों के लिए ओपन और दूरबीन विधि से सर्जिकल देखभाल।" } },
  { icon: "Stethoscope", en: { t: "General Medicine", d: "Diagnosis and management of common acute and chronic medical conditions." }, hi: { t: "जनरल मेडिसिन", d: "सामान्य तीव्र और दीर्घकालिक बीमारियों की जाँच और प्रबंधन।" } },
  { icon: "Baby", en: { t: "Obstetrics & Gynaecology", d: "Women's health, pregnancy care and gynaecological consultations." }, hi: { t: "प्रसूति एवं स्त्री रोग", d: "महिला स्वास्थ्य, गर्भावस्था देखभाल और स्त्री रोग परामर्श।" } },
  { icon: "HeartPulse", en: { t: "Normal Delivery & Caesarean", d: "Maternity care including normal delivery and caesarean section services." }, hi: { t: "सामान्य एवं सिजेरियन प्रसव", d: "सामान्य प्रसव और सिजेरियन सहित मातृत्व देखभाल सेवाएँ।" } },
  { icon: "Ambulance", en: { t: "Emergency & Trauma Care", d: "Emergency assessment and stabilisation available 24×7." }, hi: { t: "आपातकालीन एवं ट्रॉमा केयर", d: "आपातकालीन जाँच और स्थिरीकरण 24×7 उपलब्ध।" } },
  { icon: "Bath", en: { t: "Paediatrics", d: "Medical care for infants, children and adolescents." }, hi: { t: "बाल रोग", d: "शिशुओं, बच्चों और किशोरों के लिए चिकित्सा देखभाल।" } },
  { icon: "Bone", en: { t: "Orthopaedics", d: "Care for bone, joint and musculoskeletal conditions and injuries." }, hi: { t: "हड्डी रोग", d: "हड्डी, जोड़ और मांसपेशी संबंधी स्थितियों और चोटों की देखभाल।" } },
  { icon: "FlaskConical", en: { t: "Laboratory Services", d: "Routine diagnostic laboratory testing to support clinical care." }, hi: { t: "प्रयोगशाला सेवाएँ", d: "नैदानिक देखभाल हेतु नियमित जाँच प्रयोगशाला सुविधाएँ।" } },
  { icon: "Pill", en: { t: "Pharmacy Support", d: "In-house pharmacy support for prescribed medicines." }, hi: { t: "फार्मेसी सहायता", d: "निर्धारित दवाओं के लिए इन-हाउस फार्मेसी सहायता।" } },
];

export const SURGICAL = [
  { en: "Laparoscopic gallbladder surgery", hi: "लेप्रोस्कोपिक पित्ताशय सर्जरी" },
  { en: "Hernia surgery", hi: "हर्निया सर्जरी" },
  { en: "Appendix surgery", hi: "अपेंडिक्स सर्जरी" },
  { en: "Piles, fissure & fistula treatment", hi: "बवासीर, फिशर व फिस्टुला उपचार" },
  { en: "Hydrocele surgery", hi: "हाइड्रोसील सर्जरी" },
  { en: "Circumcision", hi: "खतना (सर्कमसिज़न)" },
  { en: "Lipoma & cyst removal", hi: "लिपोमा व सिस्ट निष्कासन" },
  { en: "Minor & emergency surgical procedures", hi: "छोटी व आपातकालीन सर्जिकल प्रक्रियाएँ" },
];

export const DOCTORS = [
  {
    name: "Dr. Vaibhav Verma",
    photo: "https://customer-assets-rejwkqb3.emergentagent.net/job_seva-healthcare-gaya/artifacts/jf2egdl1_Screenshot_20260806_234808_Instagram.jpg",
    qualifications: "MBBS, MS/DNB (General Surgery), FMAS, DMAS, FGIE",
    en: { role: "General & Laparoscopic Surgeon", extra: "Specialist Medical Officer, Bihar Health Department" },
    hi: { role: "जनरल एवं लेप्रोस्कोपिक सर्जन", extra: "विशेषज्ञ चिकित्सा अधिकारी, बिहार स्वास्थ्य विभाग" },
  },
  {
    name: "Dr. A. K. Verma",
    photo: "https://customer-assets-rejwkqb3.emergentagent.net/job_seva-healthcare-gaya/artifacts/69bhr68d_file_000000007d60820787999433a981b8ab.png",
    qualifications: "MBBS (RIMS), FCGP",
    en: { role: "Senior Consultant Physician", extra: "" },
    hi: { role: "वरिष्ठ परामर्शदाता चिकित्सक", extra: "" },
  },
];

export const WHY = [
  { icon: "UserCheck", en: "Experienced medical professionals", hi: "अनुभवी चिकित्सा पेशेवर" },
  { icon: "Heart", en: "Patient-focused care", hi: "मरीज़-केंद्रित देखभाल" },
  { icon: "Activity", en: "Medical & surgical services", hi: "चिकित्सा एवं सर्जिकल सेवाएँ" },
  { icon: "Siren", en: "Emergency support", hi: "आपातकालीन सहायता" },
  { icon: "MapPin", en: "Convenient location in Gaya", hi: "गया में सुविधाजनक स्थान" },
  { icon: "MessageSquare", en: "Clear communication with families", hi: "परिवारों के साथ स्पष्ट संवाद" },
];

export const GALLERY = [
  { en: "Hospital Exterior", hi: "अस्पताल का बाहरी दृश्य" },
  { en: "Entrance", hi: "प्रवेश द्वार" },
  { en: "Reception", hi: "रिसेप्शन" },
  { en: "Patient Rooms", hi: "मरीज़ कक्ष" },
  { en: "Operation Theatre", hi: "ऑपरेशन थिएटर" },
  { en: "Laboratory", hi: "प्रयोगशाला" },
  { en: "Pharmacy", hi: "फार्मेसी" },
];

// UI strings
export const T = {
  callEmergency: { en: "Call Emergency", hi: "आपातकालीन कॉल" },
  callHospital: { en: "Call Hospital", hi: "अस्पताल को कॉल करें" },
  whatsappUs: { en: "WhatsApp Us", hi: "व्हाट्सएप करें" },
  getDirections: { en: "Get Directions", hi: "दिशा-निर्देश पाएँ" },
  call: { en: "Call", hi: "कॉल" },
  whatsapp: { en: "WhatsApp", hi: "व्हाट्सएप" },
  directions: { en: "Directions", hi: "दिशा" },
  heroTitle: { en: "Compassionate Healthcare in Gaya", hi: "गया में करुणामयी स्वास्थ्य सेवा" },
  heroText: {
    en: "Jan Seva Hospital provides patient-focused medical, surgical, maternity and emergency services under experienced doctors at Sikariya More, Gaya.",
    hi: "जन सेवा हॉस्पिटल, सिकरिया मोड़, गया में अनुभवी डॉक्टरों के अधीन मरीज़-केंद्रित चिकित्सा, सर्जिकल, मातृत्व और आपातकालीन सेवाएँ प्रदान करता है।",
  },
  emergency24: { en: "Emergency services available 24×7", hi: "आपातकालीन सेवाएँ 24×7 उपलब्ध" },
  servicesTitle: { en: "Our Services", hi: "हमारी सेवाएँ" },
  servicesSub: { en: "Comprehensive medical and surgical care for the people of Gaya.", hi: "गया के लोगों के लिए व्यापक चिकित्सा और सर्जिकल देखभाल।" },
  surgicalTitle: { en: "Surgical Services", hi: "सर्जिकल सेवाएँ" },
  consultSurgeon: { en: "Consult a Surgeon", hi: "सर्जन से परामर्श करें" },
  doctorsTitle: { en: "Our Doctors", hi: "हमारे डॉक्टर" },
  aboutTitle: { en: "About Jan Seva Hospital", hi: "जन सेवा हॉस्पिटल के बारे में" },
  aboutText: {
    en: "Jan Seva Hospital is a multispeciality healthcare centre located at Sikariya More, Gaya. We provide accessible, ethical and patient-focused healthcare under experienced doctors. Our services include general and laparoscopic surgery, medicine, maternity care, emergency care, laboratory testing and pharmacy support.",
    hi: "जन सेवा हॉस्पिटल, सिकरिया मोड़, गया में स्थित एक मल्टीस्पेशलिटी स्वास्थ्य केंद्र है। हम अनुभवी डॉक्टरों के अधीन सुलभ, नैतिक और मरीज़-केंद्रित स्वास्थ्य सेवा प्रदान करते हैं। हमारी सेवाओं में जनरल और लेप्रोस्कोपिक सर्जरी, मेडिसिन, मातृत्व देखभाल, आपातकालीन देखभाल, प्रयोगशाला जाँच और फार्मेसी सहायता शामिल हैं।",
  },
  whyTitle: { en: "Why Choose Us", hi: "हमें क्यों चुनें" },
  emergencyHead: { en: "Need Urgent Medical Assistance?", hi: "तत्काल चिकित्सा सहायता चाहिए?" },
  emergencySub: { en: "Call Jan Seva Hospital for emergency guidance or visit the hospital immediately.", hi: "आपातकालीन मार्गदर्शन के लिए जन सेवा हॉस्पिटल को कॉल करें या तुरंत अस्पताल आएँ।" },
  emergencyDisc: { en: "This website does not provide emergency medical diagnosis. In a life-threatening emergency, seek immediate medical assistance.", hi: "यह वेबसाइट आपातकालीन चिकित्सा निदान प्रदान नहीं करती। जानलेवा आपात स्थिति में तुरंत चिकित्सा सहायता लें।" },
  reviewsTitle: { en: "Patient Reviews", hi: "मरीज़ों की समीक्षाएँ" },
  reviewPlaceholder: { en: "Verified patient review to be added.", hi: "सत्यापित मरीज़ समीक्षा जोड़ी जाएगी।" },
  viewReviews: { en: "View Our Google Reviews", hi: "हमारी गूगल समीक्षाएँ देखें" },
  galleryTitle: { en: "Hospital Gallery", hi: "अस्पताल गैलरी" },
  gallerySub: { en: "Photographs will be added here. Placeholders shown until real images are uploaded.", hi: "यहाँ तस्वीरें जोड़ी जाएँगी। वास्तविक चित्र अपलोड होने तक प्लेसहोल्डर दिखाए गए हैं।" },
  photoSoon: { en: "Photo to be added", hi: "फ़ोटो जोड़ी जाएगी" },
  contactTitle: { en: "Location & Contact", hi: "स्थान एवं संपर्क" },
  openingHours: { en: "Opening Hours", hi: "खुलने का समय" },
  sendEnquiry: { en: "Send an Enquiry", hi: "पूछताछ भेजें" },
  formName: { en: "Full Name", hi: "पूरा नाम" },
  formPhone: { en: "Phone Number", hi: "फ़ोन नंबर" },
  formService: { en: "Service Required", hi: "आवश्यक सेवा" },
  formDate: { en: "Preferred Consultation Date", hi: "परामर्श की पसंदीदा तिथि" },
  formMessage: { en: "Message", hi: "संदेश" },
  formConsent: { en: "I agree to be contacted by Jan Seva Hospital regarding my enquiry.", hi: "मैं अपनी पूछताछ के संबंध में जन सेवा हॉस्पिटल द्वारा संपर्क किए जाने के लिए सहमत हूँ।" },
  submit: { en: "Submit Enquiry", hi: "पूछताछ जमा करें" },
  submitting: { en: "Submitting...", hi: "भेजा जा रहा है..." },
  successMsg: { en: "Thank you! Your enquiry has been received. We will contact you soon.", hi: "धन्यवाद! आपकी पूछताछ प्राप्त हो गई है। हम शीघ्र संपर्क करेंगे।" },
  errorMsg: { en: "Something went wrong. Please call us instead.", hi: "कुछ गड़बड़ हुई। कृपया हमें कॉल करें।" },
  noSensitive: { en: "Please do not share Aadhaar, financial details or confidential medical records here.", hi: "कृपया यहाँ आधार, वित्तीय विवरण या गोपनीय चिकित्सा रिकॉर्ड साझा न करें।" },
  chooseService: { en: "Choose a service", hi: "सेवा चुनें" },
};

export const PILES = {
  title: { en: "Painless Piles & Fistula Surgery", hi: "दर्द रहित बवासीर और फिस्टुला सर्जरी" },
  sub: {
    en: "Modern daycare treatment for piles, fissure and fistula, performed by an experienced surgeon and designed for minimal discomfort and a faster return to daily life.",
    hi: "बवासीर, फिशर और फिस्टुला के लिए आधुनिक डे-केयर उपचार, अनुभवी सर्जन द्वारा किया जाता है — कम असुविधा और जल्दी सामान्य जीवन में लौटने के लिए।",
  },
  points: [
    { en: "Painless piles surgery — advanced daycare procedures with reduced post-operative discomfort.", hi: "दर्द रहित बवासीर सर्जरी — कम ऑपरेशन-पश्चात असुविधा वाली आधुनिक डे-केयर प्रक्रियाएँ।" },
    { en: "Painless fistula surgery — precise treatment focused on comfort and recovery.", hi: "दर्द रहित फिस्टुला सर्जरी — आराम और रिकवरी पर केंद्रित सटीक उपचार।" },
    { en: "Fissure treatment with a focus on quick relief and healing.", hi: "जल्दी राहत और उपचार पर ध्यान देते हुए फिशर का इलाज।" },
    { en: "Short hospital stay and clear pre- and post-operative guidance.", hi: "कम अस्पताल में रुकना और स्पष्ट ऑपरेशन-पूर्व व पश्चात मार्गदर्शन।" },
  ],
  note: {
    en: "Suitability and outcomes depend on individual clinical assessment by the surgeon. This is not a guarantee of results.",
    hi: "उपयुक्तता और परिणाम सर्जन द्वारा व्यक्तिगत नैदानिक मूल्यांकन पर निर्भर करते हैं। यह परिणामों की गारंटी नहीं है।",
  },
  cta: { en: "Consult for Piles / Fistula", hi: "बवासीर / फिस्टुला हेतु परामर्श" },
};

export const DISCLAIMER = {
  en: "Information provided on this website is for general awareness and does not replace consultation with a qualified medical professional. Treatment recommendations depend on individual clinical assessment. In an emergency, contact the hospital or visit the nearest emergency department immediately.",
  hi: "इस वेबसाइट पर दी गई जानकारी सामान्य जागरूकता के लिए है और यह किसी योग्य चिकित्सा पेशेवर के परामर्श का स्थान नहीं लेती। उपचार की सिफ़ारिशें व्यक्तिगत नैदानिक मूल्यांकन पर निर्भर करती हैं। आपात स्थिति में तुरंत अस्पताल से संपर्क करें या नज़दीकी आपातकालीन विभाग जाएँ।",
};
